import { PeriodType } from '../../scorecard.model';

import {
    RankFilter,
    ScorecardPublishStatusFilter,
    ScorecardTrendChartData,
    SuperGroupFilter,
} from './scorecard-trend-chart.model';

type ScorecardTrendCharts = Map<string /* tabId */, ScorecardTrendChart>;
type ScorecardTrendChartFiltersAndData = Map<
    PeriodType,
    ScorecardTrendChartDataFilters
>;

export enum View {
    COMPACT = 'compact',
    WIDE = 'wide',
}

export const NUM_BARS_COMPACT = 48;
export const NUM_BARS_WIDE = 18;

export interface ScorecardTrendChartDataFilters {
    periodType?: PeriodType;
    ranksFilter?: RankFilter[];
    publishStatusFilter?: ScorecardPublishStatusFilter[];
    supergroupsFilter?: SuperGroupFilter[];
    scorecardTrendChartData?: ScorecardTrendChartData;
}

export interface ScorecardTrendChart extends ScorecardTrendChartDataFilters {
    tabId: string;
    trendChartFiltersAndData: ScorecardTrendChartFiltersAndData;
}

export interface ScorecardTrendChartState {
    selectedView: View;
    trendCharts: ScorecardTrendCharts;
    selectedTrendChart?: ScorecardTrendChart;
    navigation?: {
        numPages?: number;
    };
}

export const defaultScorecardTrendChartState =
    (): ScorecardTrendChartState => ({
        selectedView: View.WIDE,
        trendCharts: new Map(),
    });

export const createInitialTrendChart = (
    periodType: number,
    tabId: string,
): ScorecardTrendChart => ({
    periodType,
    tabId,
    trendChartFiltersAndData: new Map(),
});

export const createEmptyTrendChartDataFilters = (
    periodType: number,
): ScorecardTrendChartDataFilters => ({
    periodType,
});
